import { cn } from 'util/cn'

import { css } from 'design'
import { Button } from 'primitives/button'
import { Stack } from 'primitives/containers'
import React, { useContext } from 'react'
import { useSelector } from 'react-redux'

import { useCallManager } from '../../contexts/call_manager_context'
import {
  AppLocationContext,
  TOPIC_VIEW,
} from '../../pages/admin/app_location_provider'
import { WIDGET_LAYOUT } from '../../pages/live_chat/constants'
import { WidgetContext } from '../../pages/live_chat/widget_page_router'
import { getCurrentQuestion } from '../../reduxes/slices/questions/selectors'

type Props = {
  children?: any
  bgVariant?: boolean
} & React.HTMLAttributes<HTMLDivElement>

export const WidgetHeaderBar = ({
  children,
  bgVariant = false,
  ...props
}: Props) => {
  const { appLocation } = useContext(AppLocationContext)
  const { goBack, canGoBack, widgetLayout, toggleLayout } =
    useContext(WidgetContext)
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const companyName = window?.speakeasySettings?.companyName
  const {
    activeCall: { isOnCall, navToChatView },
  } = useCallManager()
  const showChatButton =
    isOnCall && appLocation.topicView === TOPIC_VIEW.VIDEO_VIEW
  const currentQuestion = useSelector(getCurrentQuestion)

  const bg = bgVariant ? 'secondary' : 'none'

  return (
    <div className={cn(headerStyles({ bg }), props.className)}>
      <Stack
        direction={'row'}
        css={{
          justifyContent: 'space-between',
          ...(!companyName && (!currentQuestion || currentQuestion.root)
            ? {}
            : {}),

          '>*': {
            height: 40,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          },
          ...(bgVariant && {
            borderColor: 'rgba(255,255,255,0.35)',
          }),
        }}
      >
        {showChatButton ? (
          <Button
            variant={'clean'}
            className={headerButtonStyles()}
            onClick={() => navToChatView?.()}
          >
            <i className="fas fa-chevron-left" title={'Chat'} />
          </Button>
        ) : goBack && canGoBack ? (
          <Button
            variant={'clean'}
            className={headerButtonStyles()}
            onClick={goBack}
          >
            <i className="fas fa-chevron-left" title={'Back'} />
          </Button>
        ) : (
          <div />
        )}
        {widgetLayout !== WIDGET_LAYOUT.FLOATING && !collection && (
          <div className={companyNameStyles()}>{companyName}</div>
        )}
        {type === 'widget' ||
        widgetLayout === WIDGET_LAYOUT.FULLSCREEN ||
        widgetLayout === WIDGET_LAYOUT.WIDGET_MAXIMISED ? (
          <Stack direction="row" gap={2}>
            {appLocation.topicView === TOPIC_VIEW.VIDEO_VIEW && (
              <Button
                variant={'clean'}
                className={headerButtonStyles()}
                onClick={() => toggleLayout(WIDGET_LAYOUT.WIDGET_MAXIMISED)}
              >
                {widgetLayout === WIDGET_LAYOUT.WIDGET_MAXIMISED ? (
                  <i className="fas fa-window-restore" title={'Minimise'} />
                ) : (
                  <i className="fas fa-window-maximize" title={'Maximise'} />
                )}
              </Button>
            )}
          </Stack>
        ) : (
          <div />
        )}
      </Stack>
      {children}
    </div>
  )
}

const headerStyles = css({
  width: '100%',
  padding: '2px $4',
  fontSize: '$2',
  zIndex: 1,

  variants: {
    bg: {
      secondary: {
        background: 'rgba(255,255,255,0.7)',

        '.topic__theme--dark &': {
          background: 'rgba(0,0,0,0.7)',
        },
      },
      none: {},
    },
  },
})

// eslint-disable-next-line
// @ts-ignore
const { type, collection } = window.speakeasySettings || {}

const headerButtonStyles = css({
  width: '24px',
  fontSize: '$3',
  background: 'none !important',
  pointerEvents: 'auto',

  '&:hover': {
    borderColor: 'transparent !important',
  },
})

const companyNameStyles = css({
  position: 'absolute',
  left: '50%',
  transform: 'translateX(-50%)',
})
